<template>
  <add-double></add-double>
</template>
<script>
import addDouble from "@/view/double/add";
export default {
  name: "doubleAdd",
  components: {
    addDouble,
  },
};
</script>
